/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Link } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from './sectiongroupdescription_styles';



/* ========== ~~~~~~~~~~ EXPANDABLE SECTION - SECTION GROUP DESC ~~~~~~~~~~ ========== */
const SectionGroupDescription = (props) => {
  const {
    title,
    description,
    helpLink,
    titleClassName,
    descriptionClassName,
  } = props
  return <div className={`sectiongroupdescription ${props.classes.sectiongroupdescription}`}>
    <h2 className={titleClassName}>
      {title}
      {helpLink && <Link
        icon='question-circle'
        action={helpLink}
        operation='link'
        type='external'
      />
      }
    </h2>
    {description && <h4 className={descriptionClassName}>{description}</h4>}
  </div>
};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(SectionGroupDescription);